import { sharedStyles } from "./MotInvitation.shared.styles";

export const styles = {
  ...sharedStyles,
  warningIconWrapper: {
    width: "80px",
    height: "80px",
    borderRadius: "50%",
    backgroundColor: "#FFF8F0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "24px",
  },
  warningIconCircle: {
    width: "48px",
    height: "48px",
    borderRadius: "50%",
    border: "2px solid #F57C00",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  warningIconText: {
    color: "#F57C00",
    fontSize: "24px",
    fontWeight: "700",
    lineHeight: "1",
  },
  infoCard: {
    backgroundColor: "#FFFBEB",
    borderRadius: "12px",
    width: "100%",
    overflow: "hidden",
    marginBottom: "32px",
  },
  infoCardBody: {
    padding: "20px 20px 16px",
    color: "#1A2B3C",
    fontSize: "16px",
    lineHeight: "1.6",
    textAlign: "center",
    margin: "0",
  },
  infoCardDivider: {
    height: "1px",
    backgroundColor: "#E8DFC0",
    margin: "0 20px",
  },
  infoCardWarning: {
    padding: "16px 20px 20px",
    color: "#B84A0A",
    fontSize: "15px",
    fontWeight: "600",
    lineHeight: "1.5",
    textAlign: "center",
    margin: "0",
  },
  logoutButton: {
    ...sharedStyles.actionButton,
    backgroundColor: "#1B3A2D",
    color: "#4CAF50",
    gap: "10px",
  },
  logoutIconImg: {
    width: "20px",
    height: "20px",
  },
};
